<div>
    <app-input-text
        [disabled]="editDisabled()"
        [inputFormControl]="searchControl"
        [placeholder]="searchLabel()" />
    <ul
        class="grid gap-4 list-none pl-3"
        [class]="paneWidthTwoThird() ? 'grid-cols-4' : 'grid-cols-2'">
        @for (value of values(); track value.key) {
            <li>
                <label class="text-subtitle-1">
                    <div class="flex items-center">
                        <mat-checkbox
                            color="secondary"
                            [checked]="control().value.includes(value.value)"
                            [disabled]="editDisabled()"
                            (change)="selectValue(value)" />
                        <span class="pl-2 overflow-hidden text-ellipsis whitespace-nowrap">{{ value.key }}</span>
                    </div>
                </label>
            </li>
        } @empty {
            <div class="flex items-center justify-center col-span-full">
                <app-no-data-to-display
                    displayedMessage="noDataToShow"
                    iconSize="3x" />
            </div>
        }
    </ul>
    @if (!searchControl.value && displayShowMore()) {
        <app-button
            iconSize="xs"
            [disabled]="editDisabled()"
            [icon]="['fas', showAll() ? 'chevron-up' : 'chevron-down']"
            [iconPosition]="IconPosition.END"
            [label]="(showAll() ? 'displayLess' : 'displayMore') | transloco"
            [type]="ButtonType.UNDERLINE"
            (onClick)="toggle()" />
    }
</div>
